import { serviceHelper } from '../utils/serviceHelper'

export const getAppointmentById = async (id) => {
  const appointmentApi = getAxiosCreate()
  const { data } = await appointmentApi.get(`/appointments/${id}`)
  return data
}

export const createAppointment = async (params) => {
  const appointmentApi = getAxiosCreate()
  try {
    const { data } = await appointmentApi.post('/appointments', params)
    return data
  } catch (err) {
    return err.message
  }
}

export const updateAppointment = async (params) => {
  const { id, ...queryParams } = params
  const appointmentApi = getAxiosCreate()
  try {
    const { data } = await appointmentApi.put(`/appointments/${id}`, queryParams)
    return data
  } catch (err) {
    return err.message
  }
}

export const destroyAppointment = async (id) => {
  const appointmentApi = getAxiosCreate()
  try {
    return await appointmentApi.delete(`/appointments/${id}`)
  } catch (err) {
    return err.message
  }
}

export const getAppointments = async (params) => {
  const appointmentApi = getAxiosCreate()
  const { data } = await appointmentApi.get('/appointments',
    { params })
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_APPOINTMENT_URL}`)
}
